<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters, mapMutations, mapActions } from "vuex";
import Sequence from "./rightCatgory.js";
import SwitchStyle from "../rightnav/slide/search/switchStyle";
import CategoryPrompt from "../rightnav/slide/search/categoryPrompt";
import sectionCategory from "../rightnav/slide/search/sectionCategory";
import company from "../rightnav/slide/search/company";
import FilterSprites from "../rightnav/slide/search/filterSprites";
import vipLabel from "../rightnav/slide/search/vipLabel";
import Analysis from "./analysis/materialBu";

const namesDict = {
  template: "template",
  scenes: "scene",
  bg: "background",
  text: "text",
  characters: "roles",
  props: "props",
  sound: "music",
};

const itemsMaxNums = {
  "template.1": 48,
  "template.2": 48,
  "scenes.1": 48,
  "scenes.2": 48,
  "bg.1": 48,
  "bg.2": 48,
};

const offsetsOfNoCover = {
  template: 64,
  sound: 80,
};

export default {
  mixins: [Analysis],
  data() {
    return {
      boxName: "", // 素材盒子的名字
      dataArray: {}, // 数据数组
      category: [], // 获取分类标签
      dataSet: {
        // 请求数据对象--打开的素材分组
        pIndex: null,
        type: null,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      scollTop: {
        // 控制滚动条的数据
        default: 0, // 默认添加的高度
        Incremental: 120, // 单个分类的高度
        material: 88, // 单个元素的高度
        materialW: 140, // 单个元素的宽
        materialH: 233, // 竖版个元素的高度
        materialW2: 140, // 竖版单个元素的宽度
        scollTop: 0, // 判断是否定位的最初位置
        rowNum: 2, // 每行个数
      },
      fixTopId: {
        // 固定的分类
        id: null,
        top: 0,
        next: 0,
        add: true, // 滚动判断加载
        hidenShowPrompt: false, // 隐藏显示分组打开的提示
      },
      user: false, // 判断是否含有user块
      loading: false, // 加载loading
      judgeFixed: false, // 判断section--fixed
      windowMove: {
        // 窗口滚动条动作
        top: 130,
        left: 0,
      },
      addtime: null, // 唤出弹窗保存的定时器对象
      styleApiGet: false,
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 2, // 瀑布流的列数
        default: 80, // 默认添加的高度
        oldDefault: 80,
      },
      optimized: 1,
      loadLottieSetTime: null, // 播放lottie
      lottiedata: null, // 播放lottie
      rightNavFirstOpenHappened: false,
      allFav: [],
      materialLib_Nav_Param: { category: "", classify: "", optimized: "" },
    };
  },
  props: ["dataMsg", "slideState"],
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "MaterialPane_Size",
      "S_GlobalSearch",
      "S_Scenes",
      "StyleMsg",
      "TOOL",
      "SelectSprites_Msg",
      "SpriteOperation",
      "SpriteBeforeSwap",
      "scoll_Size",
      "Window_Size",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
      "SelectScenes_Msg",
      "IsVipSprites",
      "UserTeamInfo",
      "BgOperation",
      "MaterialType",
      "WorksId",
      "WorksName",
    ]),
    ...mapGetters({
      storeHand: "getHand",
      trackingData: "tracking/trackingData",
      soundHandle: "addSoundtrack/getPlayHandle",
    }),
  },
  watch: {
    S_GlobalSearch: function (val, oldval) {
      // 关键词搜索事件
      if (this.dataMsg === this.boxName) {
        Object.keys(this.dataArray).forEach((key) => {
          this.dataArray[key].judge = false;
        });
        this.dataArray.search.judge = true;
        this.dataArray.push([]); // 更新数据
        this.dataArray.shift(); // 更新数据
      }
      if (this.S_GlobalSearch) {
        // 单个打开场景搜索时才会清除数据等
        this.dataSet.keyword = this.S_Scenes.data;
      } else {
        this.waterfallComputeData.default =
          this.waterfallComputeData.oldDefault;
        this.cancelSearch();
        (this.dataArray[this.boxName] || {}).judge = true;
      }
    },
    "TOOL.optimized": function (val, oldval) {
      // 横竖版检测
      if (this.TOOL && this.TOOL.optimized) {
        // 禁掉横竖版
        switch (this.TOOL.optimized) {
          case "Horizontal":
            this.optimized = 1;
            break;
          case "Vertical":
            this.optimized = 2;
            break;
        }
      }
    },
    optimized: function (val, oldval) {
      // 横竖版检测
      if (!this.rightNavFirstOpenHappened) {
        return;
      }
      if (this.TOOL && this.TOOL.optimized) {
        switch (this.boxName) {
          case "bg":
          case "scenes":
          case "template":
          case "team":
            switch (this.optimized) {
              case 1:
                this.waterfallComputeData.listNum = 2;
                break;
              case 2:
                this.waterfallComputeData.listNum = 2;
                break;
            }
            if (val && oldval && val != oldval) {
              let categoryItem = "";
              for (categoryItem in this.dataArray) {
                delete this.dataArray[categoryItem];
              }
              this.styleApiGetFs();
            }
            break;
        }
      }
    },
    "S_Scenes.data": function (val, oldval) {
      // 关键词搜索事件
      if (this.S_GlobalSearch) {
        this.dataArray.search.data = [];
        this.dataArray.search.pIndex = 1;
        this.waterfallComputeData.default = 15;

        Object.keys(this.dataArray).forEach((key) => {
          this.dataArray[key].judge = false;
        });
        this.dataArray.search.judge = true;
        this.dataArray.push([]); // 更新数据
        this.dataArray.shift(); // 更新数据

        if (this.dataMsg === this.boxName) {
          if (this.S_GlobalSearch) {
            // 单个打开场景搜索时才会清除数据等
            this.dataSet.keyword = this.S_Scenes.data;
            this.getData();
          } else {
            this.cancelSearch();
          }
        }
      } else {
        this.waterfallComputeData.default =
          this.waterfallComputeData.oldDefault;
      }
    },
    StyleMsg: function (val, oldval) {
      // style赋值
      if (!this.rightNavFirstOpenHappened) {
        return;
      }
      // let r = this.$route;
      // if (r.template) {
      //   /* r.style &&  */this.styleApiGetFs();
      // } else {
      //   this.styleApiGetFs();
      // }

      if (this.boxName === "props") {
        this.gotoOuter();
      }
      this.styleApiGetFs().then(() => {
        // this.getOuterData && this.getOuterData();
      });
    },
    MaterialPane_Size: {
      handler(val) {
        if (val.width > 95 && !this.rightNavFirstOpenHappened) {
          this.rightNavFirstOpenHappened = true;
          this.styleApiGetFs();
        }
        // setTimeout(() => {
        //   this.$parent.handleMoreBtnPosition();
        // }, 500);
      },
      deep: true,
    },
    dataMsg: function (val, oldval) {
      // 打开盒子操作
      if (this.dataMsg === this.boxName) {
        if (this.S_GlobalSearch) {
          // 打开判断是否全局搜索
          this.dataSet.keyword = this.S_Scenes.data;
          this.getData();
        } else {
          if (!this.dataArray.length) {
            // 没有数据，请求数据
          }
        }
      }
    },
    slideState: function (val, oldval) {
      // 打开盒子操作
      this.judgeFixed = this.slideState;
    },
    "scoll_Size.top": function (val, oldval) {
      // 窗口滚动条动作
      this.windowMoveFS();
    },
    "scoll_Size.left": function (val, oldval) {
      // 窗口滚动条动作
      this.windowMoveFS();
    },
    "Window_Size.width": function (val, oldval) {
      // 窗口滚动条动作
      this.windowMoveFS();
    },
    "Window_Size.height": function (val, oldval) {
      // 窗口滚动条动作
      this.windowMoveFS();
    },
    loading(val, oldVal) {
      if (!val && oldVal) {
        this.$bus.emit("rightNav.sectionClicked");
      }
    },
  },
  mounted() {
    const vm = this;
    this.$bus.on("materialSlideSelected", (data) => {
      //第一次选中，查询数据
      if (vm.boxName === data.boxName && !vm.rightNavFirstOpenHappened) {
        vm.rightNavFirstOpenHappened = true;
        vm.styleApiGetFs();
      }
    });
    this.$bus.on("rightSlideBoxBroadcast_vue", (data) => {
      this.computeScrollTop(data.scrollTop); // 计算当前高度判断刷新等功能
    });
    this.$bus.on("searchDataUpdata_vue", (data) => {
      // 搜索开始
      if (this.dataMsg === this.boxName) {
        this.getData();
      }
    });
    this.$bus.on("categoryPromptBox_vue", (data) => {
      // 显示固定在顶部的提示栏
      if (this.boxName == data.boxName) {
        this.dataBoxAction(data.id);
      }
    });
    this.$bus.on("filterSpritesJudge", (data) => {
      // 分类预览元素接受事件
      const vm = this;
      if (vm.boxName == data.boxName) {
        vm.dataArray[data.id].data = [];
        vm.dataArray[data.id].pIndex = 1;
        if (data.fileType && data.boxName === "sound") {
          vm.dataArray[data.id].fileType = data.fileType;
          let tuple = data.fileType.split(",");
          vm.dataSet.durationMin = tuple[0];
          vm.dataSet.durationMax = tuple[1];
          if (vm.dataSet.durationMax == 600) {
            delete vm.dataSet.durationMax;
          }
        } else if (data.fileType) {
          vm.dataArray[data.id].fileType = data.fileType;
          vm.dataSet.orderBy = data.fileType;
        } else {
          delete vm.dataArray[data.id].fileType;
          delete vm.dataSet.orderBy;
          delete vm.dataSet.durationMin;
          delete vm.dataSet.durationMax;
        }
        if ("payType" in data) {
          vm.dataArray[data.id].payType = data.payType;
        } else {
          delete vm.dataArray[data.id].payType;
        }
        vm.dataArray.push([]); // 更新数据
        vm.dataArray.shift(); // 更新数据
        if (!data.judge) {
          if (vm.boxName === "template" || vm.boxName === "sound") {
            vm._getData(vm.dataArray[data.id].categoryAllData.id);
          } else {
            vm.getData(vm.dataArray[data.id].categoryAllData.id);
          }
        }
      }
    });
    this.$bus.on("settingMessage_del_vue", (data) => {
      if (data.type == this.boxName) {
        this.collectionSpriteIconFS(
          data.data.data,
          data.data.e,
          data.data.type,
          true
        );
      }
    });

    vm.$bus.on("rightSlideBoxAction_vue", (data) => {
      // 打开盒子
      if (data.type == vm.boxName) {
        if (vm.dataArray[data.name] && !vm.dataArray[data.name].judge) {
          vm.$bus.emit("filterSpritesJudge", {
            // 打开盒子清除选中的类型数据
            fileType: null,
            id: data.name,
            boxName: vm.boxName,
            judge: true,
          });
        }
      }
    });

    vm.$bus.on("favorites.toggle", (item, flag) => {
      let c = ".vipResource_" + item.id;
      if (flag) {
        $(c).addClass("collection_sprite_icon_active");
      } else {
        $(c).removeClass("collection_sprite_icon_active");
      }
    });

    // this.$bus.on('rightNav.contentGoes', (dire) => {
    //   if (this.isShowDropDownMenu != null) {
    //     this.isShowDropDownMenu = dire === 'down';
    //   }
    // })
  },
  methods: {
    ...mapActions({
      setRecent: "resources/setRecent",
    }),
    getData(categoryid) {
      // 获取数据
      this.materialLib_Nav_Param.category = categoryid;
      if (categoryid && !this.dataArray["_" + categoryid].data.length) {
        this._getData(categoryid);
      } else {
        if (categoryid) {
          this.dataArray.push([]); // 更新数据
          this.dataArray.shift(); // 更新数据
          this.$bus.emit("rightnavSlide.getDataDone");
        } else {
          this._getData();
        }
      }
    },
    _getData(categoryid, pIndex) {
      let data = Object.assign({}, this.dataSet);
      let dataURL = "common/material";
      if (categoryid) {
        if (categoryid === "template") {
          dataURL = data.type;
          data.style = this.StyleMsg;
          data.type = 8;
          // delete data.type;
        } else if (categoryid === "sound") {
          dataURL = data.type;
          data.style = this.StyleMsg;
          data.type = 5;
        } else {
          data.category = categoryid;
          categoryid = "_" + categoryid;
        }

        if ((this.dataArray[categoryid] || {}).data.length) {
          data.pIndex = this.dataArray[categoryid].pIndex;
        } else {
          data.pIndex = 1;
          this.dataArray[categoryid].pIndex = 1;
        }
        switch (this.boxName) {
          case "bg":
          case "scenes":
          case "template":
            data.direction = this.optimized;
            break;
          case "shapes":
          case "props":
            if (this.dataArray[categoryid].fileType) {
              data.fileType = this.dataArray[categoryid].fileType;
            } else {
              delete data.fileType;
            }
            break;
        }

        if ("payType" in this.dataArray[categoryid]) {
          data.payType = this.dataArray[categoryid].payType;
        } else {
          delete data.payType;
        }
      } else {
        delete data.category;
        if (this.boxName == "template") {
          dataURL = data.type;
          data.style = this.StyleMsg;
          // delete data.type;
          data.type = 8;
        }
        if (this.dataArray.search.data.length) {
          data.pIndex = this.dataArray.search.pIndex;
        } else {
          data.pIndex = 1;
          this.dataArray.search.pIndex = 1;
        }
      }
      if (!this.dataArray.search.judge && !categoryid) {
        return;
      }
      if (!categoryid) {
        this.dataArray.search.judge = false;
        this.dataArray.push([]); // 更新数据
        this.dataArray.shift(); // 更新数据
      }
      this.loading = true;
      data.draftId = window.location.hash.slice(2);
      if (data.type === 8 && data.keyword) {
        data.findAll = 1;
      }
      if (pIndex) {
        data.pIndex = pIndex;
        this.$set(this.dataArray[categoryid], "pIndex", pIndex);
      }
      return this.$http
        .get("/api/common/material", {
          params: data,
        })
        .then((res) => {
          let dataLength = 0; // 计算高度判断下拉刷新
          if (categoryid) {
            if (this.dataArray[categoryid].pIndex === 1) {
              this.dataArray[categoryid].data = [];
            }
            // for(let i = 0; i < 20; i++){
            this.dataArray[categoryid].data = this.waterfallCompute(
              this.dataArray[categoryid],
              res.data.data
            );
            dataLength = this.dataArray[categoryid].data.length;
            // }
            if (this.boxName === "template" || this.boxName === "sound") {
              this.dataArray[this.boxName].data =
                this.dataArray[categoryid].data;
            }
          } else {
            if (this.dataArray.search.pIndex === 1) {
              this.dataArray.search.data = [];
            }
            this.dataArray.search.data = this.waterfallCompute(
              this.dataArray.search,
              res.data.data,
              "search"
            );
            dataLength = this.dataArray.search.data.length;
          }
          // 定位高度
          if (dataLength) {
            if (categoryid) {
              this.dataArray[categoryid].scollTop =
                this.dataArray[categoryid].WFSheight; // 根据高度判断下拉刷新
            } else {
              this.dataArray.search.scollTop = this.dataArray.search.WFSheight; // 根据高度判断下拉刷新
            }
          } else {
            if (categoryid) {
              this.dataArray[categoryid].scollTop = 100; // 根据高度判断下拉刷新
            }
          }
          if (categoryid) {
            this.dataArray[categoryid].scollTop =
              this.dataArray[categoryid].WFSheight;
          }

          if ("data" in res.data && res.data.data.length) {
            if (categoryid) {
              this.dataArray[categoryid].pIndex++;
            } else {
              this.dataArray.search.pIndex++;
              this.dataArray.search.judge = true;
              this.$bus.emit("addSearchData_vue", { data: true });
              // let names = {
              //   3: '背景',
              //   5: '音乐',
              //   8: '模板',
              //   12: '场景页',
              //   14: '人物',
              //   16: '文字',
              //   17: '道具',
              // }
              // sensors.track('searchResult', {
              //   search_source: '编辑器素材栏',
              //   keyword: data.keyword,
              //   has_result: !!(res.data.data && res.data.data.length),
              //   material_type: names[data.type],
              //   search_type: '素材搜索',
              //   search_result_num: res.data.data.length,
              //   keyword_type: this.trackingData.keyword_type || '手动输入',
              // });
            }
          } else {
            if (!categoryid) {
              this.dataArray.search.judge = false;
            }
          }
          this.dataArray.push([]); // 更新数据
          this.dataArray.shift(); // 更新数据
          this.loading = false;
          this.$bus.emit("rightnavSlide.getDataDone");
          if (res.data.data.length) {
            this.scollTop.add = true;
          }
        });
    },
    getUserUrl(personal, data) {
      var url = "";
      switch (this.boxName) {
        case "personal":
          if (this.personalTab == "personalCategory") {
            switch (personal) {
              case "scene":
                url = "user/scene";
                break;
              case "pic":
                url = "user/pic";
                break;
              case "music":
                url = "user/music";
                break;
              // case "musicType":
              //   url = "user/music";
              //   data.musicType = 1;
              //   break;
              case "video":
                url = "user/video";
                data.fileType = 26;
                break;
              case "gif":
                url = "user/pic";
                data.fileType = 34;
                break;
            }
          } else {
            switch (personal) {
              case "scenes":
                url = "user/scene";
                break;
              case "template":
                url = "user/template";
                break;
              default:
                url = "user/favorites/type";
                data.fPage = data.fPage;
                data.type = this.collectionCategory[personal].type;
            }
          }
          break;
        case "team":
          url = "user/account/family/material";
          switch (personal) {
            case "pic":
              data.type = 4;
              break;
            // 背景音乐
            case "music":
              data.type = 5;
              //data.musicType = 0;
              break;
            // 录音
            // case "musicType":
            //   data.type = 5;
            //   data.musicType = 1;
            //   break;
            case "video":
              data.type = 1;
              data.fileType = 26;
              data.share = 1;
              break;
            case "template":
              url = "user/account/template?";
              data.type = "temp";
              data.share = 1;
              data.direction = this.TOOL.optimized == "Vertical" ? 2 : 1;
              break;
            case "teamTemplate":
              url = "user/account/cooperation/templateR";
              data.type = 1;
              break;
            case "logo":
              url = "user/brand/logo";
              break;
          }
          break;
      }
      return url;
    },
    getUserData(personal, category) {
      // 获取用户的数据--父子账号设置
      const vm = this;
      if (
        !(this.UserTeamInfo && 0 <= this.UserTeamInfo.type) &&
        this.boxName == "team"
      )
        return;
      let data = {
        sOfPage: 24,
        fPage: 24,
        pIndex: vm.dataArray[personal].pIndex,
      };
      let url = this.getUserUrl(personal, data);

      // 文件夹分类
      if (this.cateOptions) {
        let cate = this.cateOptions[this.selectedCateIndex] || {};
        category = cate.id;
      }
      if (category) {
        data.category = category;
      }

      if (this.boxName != "team" && personal == "template") {
        data.type = 3;
      }
      if (personal === "video") {
        data.type = 1;
      }
      this.loading = true;
      this.$http
        .get("/api/" + url, {
          params: data,
        })
        .then((res) => {
          let dataLength = 0;
          if (data.pIndex == 1) {
            this.dataArray[personal].data = res.data.data;
          } else {
            this.dataArray[personal].data = this.dataArray[
              personal
            ].data.concat(res.data.data);
          }
          if (res.data.data.length) {
            this.dataArray[personal].pIndex++;
          }

          dataLength = this.dataArray[personal].data.length;
          this.dataArray[personal].scollTop =
            Math.ceil(dataLength / this.scollTop.rowNum) *
            this.scollTop.material; // 根据高度判断下拉刷新
          if (dataLength) {
            this.dataArray[personal].scollTop =
              this.dataArray[personal].scollTop;
          } else {
            this.dataArray[personal].scollTop =
              100 + this.dataArray[personal].fixTop;
          }
          this.dataArray[personal].scollTop =
            120 + this.dataArray[personal].scollTop;

          this.dataArray.push([]); // 更新数据
          this.dataArray.shift(); // 更新数据
          this.loading = false;
          this.$bus.emit("personalDataPick_vue", {
            name: personal,
            pIndex: this.dataArray[personal].pIndex - 1,
          });
          if (res.data.data.length) {
            this.scollTop.add = true;
          }
        });
    },
    dataBoxAction(categoryid) {
      // 关闭所有的素材分类盒子
      if (this.fixTopId.hidenShowPrompt) {
        // 显示固定在顶部的提示栏
        this.fixTopId.hidenShowPrompt = false;
        this.fixTopId.id = null;
      }

      if (categoryid && (this.dataArray[categoryid] || {}).judge) {
        this.dataArray[categoryid].judge = false;
        this.fixTopId.top = this.scollTop.scollTop;
        this.$bus.emit("rightSlideBoxScrollTop_vue", {
          scrollTop: this.scollTop.scollTop,
        });
        this.fixTopId.id = null;
      } else if (categoryid) {
        (this.dataArray[categoryid] || {}).judge = true;
        this.scollTop.add = true;
      }
      Object.keys(this.dataArray).forEach((key) => {
        if (categoryid !== key) {
          this.dataArray[key].judge = false;
        }
      });
      if (categoryid) {
        this.dataArray.push([]); // 更新数据
        this.dataArray.shift(); // 更新数据
        this.$bus.emit("rightSlideBoxAction_vue", {
          type: this.boxName,
          name: categoryid,
          judge: this.dataArray[categoryid]
            ? this.dataArray[categoryid].judge
            : false,
        });
      }
    },
    scrollTop(index) {
      // 定位滚动窗口的位置
      let addH = 0;
      let top =
        this.scollTop.default + index * this.scollTop.Incremental - addH;

      // if (!top) {
      //   top = 5;
      // }
      this.scollTop.scollTop = top;
      let timeoutid = setTimeout(() => {
        this.$bus.emit("rightSlideBoxScrollTop_vue", {
          type: this.boxName,
          scrollTop: top,
        });
        clearTimeout(timeoutid);
      }, 100);
    },
    computeScrollTop(data) {
      // 计算当前高度判断刷新等功能
      const vm = this;
      if (vm.$el.style.display === "none") {
        return;
      }
      let max = 60;
      let currentBox = $(this.$parent.$el).children(":visible").eq(0);
      let dataType = currentBox.data("type");
      let comp = this.$parent.$refs[dataType];
      let dictKey = `${dataType}.${(comp || {}).optimized}`;
      max = itemsMaxNums[dictKey] || max;
      if (
        this.scollTop.scollTop ||
        this.scollTop.scollTop === 0 ||
        this.boxName == "template" ||
        this.boxName === "sound"
      ) {
        if (data > this.scollTop.scollTop) {
          Object.keys(this.dataArray).forEach((key) => {
            if (vm.dataArray[key].judge) {
              // || key == 'template'
              if (data > vm.dataArray[key].fixTop + 140) {
                // 显示固定在顶部的提示栏
                vm.fixTopId.hidenShowPrompt = true;
                vm.fixTopId.id = key;
              } else {
                vm.fixTopId.hidenShowPrompt = false;
                vm.fixTopId.id = null;
              }
              // let innerMax = key === 'search' || vm.boxName === 'personal' || vm.boxName === 'team' ? Infinity : max;
              if (
                data >
                vm.fixTopId
                  .top /* && vm.dataArray[key].data.length < innerMax */
              ) {
                // this.fixTopId.id  = key;
                vm.fixTopId.top = data;
                let isadd = data - vm.fixTopId.next, // 达到加载位置加载
                  judgeAdd =
                    vm.dataArray[key].scollTop -
                    vm.dataArray[key].fixTop -
                    vm.MaterialPane_Size.height +
                    130; // judgeAdd加载位置
                if (offsetsOfNoCover[vm.boxName]) {
                  judgeAdd -= offsetsOfNoCover[vm.boxName];
                }
                if (isadd >= 0 && data >= judgeAdd && vm.scollTop.add) {
                  // 根据高度判断下拉刷新
                  vm.scollTop.add = false;
                  if (vm.boxName === "personal" || vm.boxName === "team") {
                    vm.getUserData(key);
                  } else {
                    if (vm.S_GlobalSearch) {
                      vm._getData();
                    } else {
                      let keyId;
                      if (key === "template" || key === "sound") {
                        keyId = key;
                      } else {
                        keyId = key.slice(1);
                      }
                      vm._getData(keyId);
                    }
                  }
                }
                vm.fixTopId.next = data; // 记录实时的滚动位置
              } else {
                // --这块代码是滚动素材的时候超过素材分组高度就关闭分组用的---
                // let rightScroll =  (this.dataArray[key].scollTop + this.RightNav_Size.height - 250 - 50); // 30 -> 预留空间
                // if(data > rightScroll){
                // let scrollTop = this.dataArray[key].fixTop;
                // this.$bus.emit("rightSlideBoxScrollTop_vue", { type: this.boxName, scrollTop:  scrollTop});
                // this.dataArray[key].judge = false;
                // this.fixTopId.top = this.scollTop.scollTop;
                // this.fixTopId.id  = null;
                // }
                // -----
              }
            }
          });
        } else {
          this.fixTopId.top = this.scollTop.scollTop;
          this.fixTopId.hidenShowPrompt = false;
          this.fixTopId.id = null;
        }
      }
    },
    cancelSearch() {
      // 取消搜索
      delete this.dataSet.keyword;
      this.dataArray.search.data = [];
      this.dataArray.search.judge = false;
      this.dataArray.push([]); // 更新数据
      this.dataArray.shift(); // 更新数据
      this.dataArray.search.pIndex = 1;
    },
    slidAddSprites(data, key) {
      let navType = this.$store.getters["materialArea/getChoosedResourceType"];
      let typeMap = {
        scene: "scene",
        template: "template",
        bg: "background",
        word: "text",
        role: "character",
        visual: "material",
        music: "sound",
      };
      this.$store.commit("resources/setAddingData", {
        type: data.originalType || typeMap[navType.key],
        id: data.characterId || data.id,
      });
      // let isPrivate = $('#app .secondMenuPane .personal .personal_tab>div').eq(0).hasClass('active') && $('#app .secondMenuPane .personal').css('display') !== 'none';
      let isPrivate =
        this.dataMsg === "personal" && this.personalTab === "personalCategory";
      if (data.isPrivate) {
        isPrivate = data.isPrivate;
      }
      let isUser = isPrivate;
      let trackingList = [0, 0, 0, 0];
      if (isPrivate) {
        trackingList[0] = 1;
      }
      // 添加元素
      if (!data.fileType) {
        let fileType = data.url.split(".")[1];
        data.fileType = fileType;
      }
      const isGif = (name) => /\.(gif|apng)$/i.test(name);
      const gifOrImage = (name) => (isGif(name) ? "Gif" : "Image");
      console.log(`Turbo ~ slidAddSprites ~ data`, data)
      switch (data[key] || data.fileType) {
        case 1: // png/jpg/jpeg--背景
        case 3: // png/jpg/jpeg--道具
        case 6: // png/jpg/jpeg--形状
        case 11: // png/jpg/jpeg--文字
        case 18: // png/jpg/jpeg--图片
        case "PNG":
        case "png":
        case "JPG":
        case "jpg":
        case "JPEG":
        case "jpeg":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: gifOrImage(data.url),
                optionForAdd: {
                  trackingType: trackingList.join(""),
                  isUser: isUser,
                  url: data.url,
                  resourceId: data.id, // 资源id
                  source: data.source,
                  fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              gifOrImage(data.url),
              {
                trackingType: trackingList.join(""),
                isUser: isUser,
                url: data.url,
                resourceId: data.id,
                source: data.source,
                fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                isLoop: false,
                effectCode: "FadeIn",
              },
              null,
              true
            );
          }
          break;
        case 32:
        case 33:
        case 34:
        case 118: // gif角色
        // 数字人
        case 57:
        case 100:

        case "GIF":
        case "gif":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            if (sprite.type === "Video") {
              sprite.isLoop = sprite.video.loop;
              sprite.numberOfLoops = sprite.video.repeatTimes;
            }

            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: gifOrImage(data.url),
                optionForAdd: {
                  trackingType: trackingList.join(""),
                  isUser: isUser,
                  url: data.url,
                  resourceId: data.id, // 资源id
                  source: data.source,
                  fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                  isLoop:
                    typeof sprite.isLoop === "boolean"
                      ? sprite.isLoop
                      : sprite.option.isLoop,
                  numberOfLoops: sprite.numberOfLoops,
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              gifOrImage(data.url),
              {
                trackingType: trackingList.join(""),
                isUser: isUser,
                url: data.url,
                resourceId: data.id || uuid.generate(),
                source: data.source,
                fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                effectCode: "FadeIn",
              },
              null,
              true
            );
          }
          break;
        case 4: // svg--道具
        case 7: // svg--形状
        case 12: // svg--文字
        case 19: // svg--图片
        case 22:
        case 23:
        case 28: // svg--可编辑形状
        case 29: // svg--可编辑线条
        case "svg":
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "Svg",
                optionForAdd: {
                  url: data.url,
                  resourceId: data.id, // 资源id
                  source: data.source,
                  fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                  trackingType: trackingList.join(""),
                  isUser: isUser,
                },
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              "Svg",
              {
                url: data.url,
                resourceId: data.id,
                source: data.source,
                fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                effectCode: "None",
                trackingType: trackingList.join(""),
                isUser: isUser,
              },
              null,
              false
            ).then((sprite) => {
              sprite
                .updateEffect({
                  code: "Hand",
                  entranceAnim: {
                    hand: this.storeHand,
                  },
                })
                .then(() => {
                  // s.updateEffect并不会记录到undo中，所以只能重新写undo
                  let data = sprite.toJson(true);
                  data.scenesId = sprite.scenesId;
                  data.scale = this.TOOL.scale;
                  eve("undo_redo", null, { type: "addSprite", data: data });
                  this.TOOL.selectSprite([sprite]);
                });
            });
          }
          break;
        case 5: // lottie--道具
        case 8: // lottie--形状
        case 10: // lottie--角色
        case 47: // Lottie--矢量动图
        case "json":
          let soundData = null,
            spriteData = {};
          if (data && data.soundFillType && data.soundUrl) {
            data.fileType = data.soundFillType;
          }

          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;

            if (sprite.type === "Video") {
              sprite.isLoop = sprite.video.loop;
              sprite.numberOfLoops = sprite.video.repeatTimes;
            }

            spriteData = {
              sprite,
              typeForAdd: "Lottie",
              optionForAdd: {
                lottieOptions: {
                  path: this.$handleAssetsUrl(data.url),
                  loop: 4,
                  autoplay: true, // 控制播放
                },
                resourceId: data.id, // 资源id
                source: data.source,
                fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
                characterId: data.id, // 选中那个
                isLoop:
                  typeof sprite.isLoop === "boolean"
                    ? sprite.isLoop
                    : sprite.option.isLoop,
                numberOfLoops: sprite.numberOfLoops,
              },
            };
          } else {
            spriteData = {
              lottieOptions: {
                path: this.$handleAssetsUrl(data.url),
                loop: 4,
                autoplay: true, // 控制播放
              },
              resourceId: data.id, // 资源id
              source: data.source,
              fileType: isNaN(data.fileType) ? null : data.fileType, // 资源type
              characterId: data.id, // 选中那个
              effectCode: "FadeIn",
            };
          }

          if (data && data.soundFillType && data.soundUrl) {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            soundData = {
              url: data.soundUrl,
              title: data.title,
            };

            if (this.SpriteOperation === "swap") {
              spriteData.optionForAdd.sound = soundData;
              spriteData.optionForAdd.numberOfLoops =
                sprite.numberOfLoops ||
                (sprite.option || {}).numberOfLoops ||
                3;
              spriteData.optionForAdd.lottieOptions.loop = 3;
            } else {
              spriteData.sound = soundData;
              spriteData.isLoop = true;
              spriteData.numberOfLoops = 3;
              spriteData.lottieOptions.loop = 3;
            }
          }
          if (this.SpriteOperation === "swap") {
            this.TOOL.swapSprite(spriteData, true);
          } else {
            this.TOOL.addSprite("Lottie", spriteData, null, true);
          }

          break;
        case 9: // 图表-json-形状
          _fetch(data.url)
            .then((styleRes) => {
              return styleRes.text();
            })
            .then((styleData) => {
              _fetch(data.sampleUrl)
                .then((sampleRes) => {
                  return sampleRes.text();
                })
                .then((sampleData) => {
                  this.$bus.emit("insert-chart", {
                    style: JSON.parse(styleData),
                    data: JSON.parse(sampleData),
                    resourceId: data.id,
                    source: data.source,
                    fileType: data.fileType,
                    chartType: data.shapeType,
                  });
                });
            });
          break;
        case 13: // 静态素材-json-文字
          break;
        case 30: {
          // 文字组合
          const runner = () => {
            return fetch(this.$handleAssetsUrl(data.url))
              .then((res) => {
                return res.json();
              })
              .then((json) => {
                let groupData = {
                  id: data.id + "," + uuid.generate(),
                  fileType: data.fileType,
                  resourceId: data.id,
                  source: data.source,
                  thumbnailUrl: data.thumbnailUrl,
                };

                switch (this.boxName) {
                  case "text":
                    groupData.type = 16;
                    break;
                  case "props": // 道具
                    groupData.type = 17;
                    break;
                  case "shapes": // 形状
                    groupData.type = 15;
                    break;
                }
                let sizeW = 1920;
                let sizeH = (1920 * 9) / 16;
                let arrX = [];
                let arrY = [];
                let minX = 0;
                let minY = 0;
                json.forEach((s) => {
                  let { x, y, width, height } = s.outward;
                  let sizeX = Math.max(0, x) + width;
                  let sizeY = Math.max(0, y) + height;
                  arrX.push(sizeX);
                  arrY.push(sizeY);
                  if (x < minX) {
                    minX = x;
                  }
                  if (y < minY) {
                    minY = y;
                  }
                });
                let sizeX = Math.max.apply(null, arrX) - minX;
                let sizeY = Math.max.apply(null, arrY) - minY;

                json.forEach((s, i) => {
                  s._scale = 1 / this.TOOL.scale;
                  s.fileType -= 0;
                  s.zIndex = this.TOOL.selectedScenes.sprites.length + i;
                  // if (this.SelectScenes_Msg.duration < s.startTime * 1000) {
                  //   s.startTime = Math.floor(this.SelectScenes_Msg.duration / 1000 - 0.5)
                  // }
                  s.outward.x = s.outward.x + sizeW / 2 - sizeX / 2;
                  s.outward.y = s.outward.y + sizeH / 2 - sizeY / 2;

                  let isNearTimeEnd =
                    this.SelectScenes_Msg.duration / 1000 -
                      this.SelectScenes_Msg.nowTime <=
                    0.5;
                  if (isNearTimeEnd) {
                    this.SelectScenes_Msg.nowTime =
                      this.SelectScenes_Msg.duration / 1000 - 0.5;
                  }
                  if (s.enterEffect.type === "None") {
                    // s.startTime = isNearTimeEnd ? 0 : this.SelectScenes_Msg.nowTime;
                    s.startTime = this.SelectScenes_Msg.nowTime;
                    s.enterEffect.duration = 0;
                    s.stayEffect.duration =
                      this.SelectScenes_Msg.duration / 1000 - s.startTime;
                  } else {
                    // s.startTime = isNearTimeEnd ? 0.5 : this.SelectScenes_Msg.nowTime - 0.5;
                    s.startTime = this.SelectScenes_Msg.nowTime - 0.5;
                    s.enterEffect.duration = 0.5;
                    s.stayEffect.duration =
                      this.SelectScenes_Msg.duration / 1000 - s.startTime - 0.5;
                  }

                  // s.startTime = this.SelectScenes_Msg.nowTime;

                  s.exitEffect.type = "None";
                  s.exitEffect.duration = 0;
                  s.groupId = groupData;
                  // s.stayEffect.duration =  this.SelectScenes_Msg.duration / 1000 - s.startTime;
                });
                return this.SelectScenes_Msg.toFromJson(json, 1, true).then(
                  () => {
                    this.$bus.emit("addCanvas", data);
                    let sprites = this.TOOL.selectedScenes.sprites;
                    let arr = sprites.slice(-json.length);
                    let maxEnter = 0;
                    let arrS = [];
                    let arrS2 = [];
                    arr.forEach((sprite) => {
                      if (sprite.effect.entranceAnim.end > maxEnter) {
                        maxEnter = sprite.effect.entranceAnim.end;
                      }
                      if (
                        !(
                          sprite.effect.pathAnim &&
                          sprite.effect.pathAnim.target
                        )
                      ) {
                        arrS.push(sprite);
                      }
                      arrS2.push(sprite);
                    });
                    this.TOOL.selectSprite(arrS);
                    eve("timeline_nowTime_change", null, {
                      nowTime: maxEnter / 1000 + 0.5,
                      noPlay: true,
                    });
                    // this.$bus.emit('addCanvas', data);
                    return arrS2;
                  }
                );
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: "文字组合加载失败，请重试",
                });
              });
          };
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "group",
                optionForAdd: {
                  source: data.source,
                  callback: runner,
                },
              },
              true
            );
          } else {
            runner();
          }

          break;
        }
        case 35: // 相框
          if (this.loading) {
            return;
          }
          this.loading = true;
          const loadingDone = () => {
            this.loading = false;
          };
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            let optionForAdd = {
              url: data.url,
              resourceId: data.resourceId,
              source: data.source,
              fileType: data.fileType,
              picUrl: sprite.option.picUrl,
            };
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "Frame",
                optionForAdd,
              },
              true
            )
              .then(loadingDone)
              .catch(loadingDone);
          } else {
            this.TOOL.addSprite(
              "Frame",
              {
                url: data.url,
                resourceId: data.id,
                source: data.source,
                fileType: data.fileType,
              },
              null,
              true
            )
              .then(loadingDone)
              .catch(loadingDone);
          }
          break;

        // 视频
        case 26:
        // case 100:
        // case 57:
        case 27:
          if (this.SpriteOperation === "swap") {
            let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
            let optionForAdd = {
              trackingType: trackingList.join(""),
              url: data.url,
              userId: data.userId,
              resourceId: data.id, // 资源id
              source: data.source,
              fileType: isNaN(data.fileType) ? null : data.fileType,
              thumbnailUrl: data.thumbnailUrl,
              actionType: data.type,
              video: {
                ...sprite.video,
                startTime: 0,
                cutDuration: void 0,
                volume: 50,
                poster: data.thumbnailUrl,
                loop:
                  sprite.isLoop == null
                    ? (sprite.video || {}).loop
                    : sprite.isLoop,
                repeatTimes:
                  sprite.numberOfLoops || (sprite.video || {}).repeatTimes,
              },
            };
            this.TOOL.swapSprite(
              {
                sprite,
                typeForAdd: "Video",
                optionForAdd,
              },
              true
            );
          } else {
            this.TOOL.addSprite(
              "Video",
              {
                trackingType: trackingList.join(""),
                actionType: data.type,
                url: data.url,
                userId: data.userId,
                resourceId: data.id, // 资源id
                source: data.source,
                fileType: isNaN(data.fileType) ? null : data.fileType,
                thumbnailUrl: data.thumbnailUrl,
              },
              true
            );
          }
          break;
        case 42:
          let spriteType = data.url.split(".")[1];
          let itemData = data;
          itemData.fileTypeNew = "json";
          itemData.soundFillType = itemData.fileType;
          // delete itemData.fileType;
          itemData.soundUrl = this.$handleAssetsUrl(itemData.soundUrl);
          this.slidAddSprites(itemData, "fileTypeNew");
          break;
      }
    },

    upodatasecens(data, type, scenesData) {
      // itemL.id, 'material', { favorites: true }
      // 更新当前分组添加场景
      let dataMsg = {
          type: 12,
          id: data,
        },
        dataUrl = "/api/common/material";
      if (
        this.boxName == "personal" &&
        this.personalTab == "collectionCategory"
      )
        type = 1; // 个人收藏的判断 // data为场景id
      switch (type) {
        case 0:
          dataUrl = "/api/user/scene";
          break;
        default:
          if (scenesData && scenesData.favorites) {
            // 已经收藏的场景
            dataUrl = "/api/common/material";
            dataMsg.draftId = window.location.hash.slice(2);
          } else {
            dataUrl = "/api/user/scene"; // 未收藏
          }
          break;
      }
      this.$http
        .get(dataUrl, {
          params: dataMsg,
        })
        .then(async (res) => {
          let scenesJson = null;
          let scale = 1;
          switch (type) {
            case 0:
              scenesJson = JSON.parse(res.data.data.data);
              scenesJson.resourceId = dataMsg.id;
              break;
            default:
              if (scenesData && scenesData.favorites) {
                scenesJson = JSON.parse(res.data.data[0].data);
                scenesJson.resourceId = dataMsg.id;
              } else {
                scenesJson = JSON.parse(res.data.data.data);
                scenesJson.resourceId = dataMsg.id;
              }
              break;
          }
          scale =
            this.TOOL.clientWidth /
            (scenesJson.resolution ? scenesJson.resolution.width : 1920);
          this.$store.commit("del_vipSprites", {
            id: "BG-" + this.SelectScenes_Msg.id,
          });
          delete scenesJson.exitEffect;
          // 配音添加
          let addSounds = [];
          let changeTime = [0, 0, 0];
          let scenes = this.TOOL.sprites;
          for (let i = 0; i < scenes.length; i++) {
            if (scenes[i].id === this.SelectScenes_Msg.id) {
              changeTime[1] =
                changeTime[0] + this.SelectScenes_Msg.duration / 1000;
              changeTime[2] = changeTime[0] + scenesJson.duration;
              break;
            }
            changeTime[0] += scenes[i].duration / 1000;
          }
          // 兼容老项目数据（没有自测）
          if (!scenesJson.dubbing && scenesJson.sound) {
            let sound = scenesJson.sound[0];
            let music = {
              id: sound.resourceId,
              title: sound.title,
              fileType: sound.fileType,
              url: sound.url,
              cut: [sound.startTime, sound.endTime],
              timeSlot: [changeTime[0], changeTime[2]],
            };
            let duration = await this.loadSound(sound.url);
            if (duration > 0.3) {
              if (!sound.endTime) {
                music.cut = [0, duration];
              }
              music.timeSlot[1] =
                music.timeSlot[0] +
                Math.min(music.cut[1] - music.cut[0], scenesJson.duration);
              addSounds.push(music);
            }
          }
          if (scenesJson.dubbing) {
            let dub = null;
            for (let i = 0; i < scenesJson.dubbing.length; i++) {
              dub = scenesJson.dubbing[i];
              addSounds.push({
                id: dub.resourceId,
                title: dub.title,
                fileType: dub.fileType,
                url: dub.url,
                timeSlot: [
                  changeTime[0] + dub.timeSlot[0],
                  changeTime[0] + dub.timeSlot[1],
                ],
                cut: [...dub.cut],
              });
            }
          }
          let addSubtitles = [];
          if (scenesJson.subtitles) {
            let sub = null;
            for (let i = 0; i < scenesJson.subtitles.length; i++) {
              sub = scenesJson.subtitles[i];
              addSubtitles.push(Object.assign({}, sub, {
                startTime: changeTime[0] + sub.startTime,
                endTime: changeTime[0] + sub.endTime
              }))
            }
          }
          let undoDubbing = this.soundHandle.getDubbingTS(changeTime);
          let subtitles = []
          this.$store.commit('subtitle/getSubtitleTS', {timeSlot: changeTime, subtitles});
          this.soundHandle.updateScenesSound(changeTime, addSounds);
          this.$store.commit('subtitle/updateScenesSound', { changeTime, subtitles: addSubtitles });
          let dubbingData = {
            dubbing: addSounds,
            undoDubbing: undoDubbing,
          };
          let subtitleData = {
            subtitles: addSubtitles,
            undoSubtitles: subtitles
          }

          this.SelectScenes_Msg.toFromJson(
            scenesJson,
            scale,
            true,
            {
              dubbingData,
              subtitleData
            }
          ).then(() => {
            scenesJson = null;
            this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
            // this.$store.commit('rm_scenesVipSprites', { id: this.SelectScenes_Msg.id });
            this.$bus.emit("judgeItemPayType_vue", {
              type: "scenes",
              id: this.SelectScenes_Msg.id,
              option: {
                resourceId: dataMsg.id, // 背景资源id
                fileType: 24, // 背景资源type
              },
              opHelper: {
                isSvip: false,
              },
              scenesId: this.SelectScenes_Msg.id,
            });
          });
        });
    },
    loadSound(src) {
      let audioEle = document.createElement("audio");
      audioEle.src = this.$handleAssetsUrl(src);

      return new Promise(function (resolve) {
        let t = setTimeout(() => {
          resolve(0);
        }, 10000);
        audioEle.onloadedmetadata = () => {
          resolve(audioEle.duration);
          audioEle.onloadedmetadata = null;
          audioEle = null;
        };
        audioEle.onerror = () => {
          resolve(0);
        };
      });
    },
    settingScenesBg(data) {
      let isPrivate =
        this.dataMsg === "personal" && this.personalTab === "personalCategory";
      let trackingList = [0, 0, 0, 0];
      if (isPrivate) {
        trackingList[0] = 1;
      }
      // 设置分组背景
      let type =
        data.fileType === 25 || data.fileType === 26 ? "Video" : "Image";
      let sceneBgProps = this.SelectScenes_Msg.background;
      let bgOpts = {
        trackingType: trackingList.join(""),
        // 设置场景背景
        resourceId: data.id, // 背景资源id
        fileType: data.fileType, // 背景资源type
        source: data.source,
        type, // 背景类型 0:Color 1:Image 2:Video
        data: {
          // 颜色背景的数据
          url: data.url, // 颜色值,8位数
          blur: 0, // 高斯模糊
          opacity: 1, // 透明度
        },
        videoStartTime: 0,
        videoEndTime: parseInt(this.SelectScenes_Msg.duration / 1000),
        zoomActive: false,
      };

      if (this.BgOperation === "swap") {
        bgOpts.data = {
          ...sceneBgProps.data.data,
          url: data.url,
        };
        bgOpts.zoomActive = sceneBgProps.zoomActive;
        bgOpts.zoomOptions = sceneBgProps.zoomOptions;
        bgOpts.filter = sceneBgProps.filter;
        bgOpts.laying = sceneBgProps.data.laying;
      } else {
      }

      if (type === "Video") {
        this.$bus.emit("confirmAddVideo", {
          type: "bg", // 'bg' 'sprite'
          data: data,
        });
      } else {
        this.SelectScenes_Msg.setBackground(bgOpts, null, true);
        this.$bus.emit("judgeItemPayType_vue", {
          type: "bg",
          id: "BG-" + this.SelectScenes_Msg.id,
          option: {
            resourceId: data.id, // 背景资源id
            fileType: data.fileType, // 背景资源type
          },
          opHelper: {
            isSvip: false,
          },
          scenesId: this.SelectScenes_Msg.id,
        });
      }

      if (this.BgOperation === "swap") {
        type === "Video" || this.$store.commit("save_BgOperation", "add");
      } else {
        // this.SelectScenes_Msg.setBgZoom(false);
      }

      this.$store.commit("del_vipSprites", {
        id: "BG-" + this.SelectScenes_Msg.id,
      });
    },
    windowMoveFS() {
      // 窗口滚动条动作
      this.windowMove.top = 130 - this.scoll_Size.top;
      this.windowMove.left =
        this.Window_Size.width > 1300
          ? this.Window_Size.width - 352
          : 1300 - 352 - this.scoll_Size.left;
    },
    async getCharacters(el, data, type, judgeTytpe) {
      // 唤出弹出框
      if (type) {
        data.fileType = data.action[0].fileType;
      }
      if (judgeTytpe) {
        data.judgeTytpe = judgeTytpe;
      }
      this.$bus.emit("itemPreview_vue", {
        data: data,
      });

      let boxName = this.boxName;
      if (
        this.boxName == "personal" &&
        this.personalTab == "collectionCategory"
      ) {
        boxName = "characters";
      }

      this.addtime = setTimeout(() => {
        this.$bus.emit("FeaturesPop_vue", {
          name: "charactersSprite",
          posx: el.pageX - el.offsetX - 40,
          posy: el.pageY - el.offsetY,
          data: data,
          type: 2,
          boxName: boxName,
          id: data.id,
        });
        if (this.addtime) {
          clearTimeout(this.addtime);
        }
      }, 1000);
      if (data.source == 5 && !data.url && boxName === "bg") {
        let resp = await this.$http.get(
          `/api/user/sheTuWang/materialData?type=3&id=${data.id}`
        );
        let item = resp.data.data;
        data.url = (item || {}).url;
      }
    },
    closeCharacters() {
      // 关闭弹出框
      if (this.addtime) {
        clearTimeout(this.addtime);
      }
      this.$bus.emit("setTimeOut_vue", {
        name: "proviewIremData",
      });
    },
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    styleApiGetFs(personalTab) {
      // 获取所有的分类
      if (this.S_GlobalSearch) {
        this.$bus.emit("search-OpenClose", { type: false });
      }
      this.dataArray.search = {}; // 搜索数据
      this.dataArray.search.data = []; // 数据
      this.dataArray.search.pIndex = 1; // 获取页码
      this.dataArray.search.judge = false; // 判断盒子打开关闭
      this.dataArrayAddWFC(this.dataArray.search, "search");

      switch (this.boxName) {
        case "personal":
        case "team":
          let categoryListData = Object.assign({}, this.personalCategory);
          let categoryList = [];
          this.category = [];

          if (this.boxName == "personal") {
            if (personalTab && personalTab == "collectionCategory") {
              categoryListData = Object.assign({}, this.collectionCategory);
            }
          }
          Object.keys(categoryListData).forEach((key) => {
            let index = categoryList.length,
              top = 0;
            top = this.scollTop.default + index * this.scollTop.Incremental;
            categoryList.push(categoryListData[key]);
            this.dataArray[key] = {}; // 分类数据总对象
            this.dataArray[key].data = []; // 保存数据
            this.dataArray[key].pIndex = 1; // 获取页码
            this.dataArray[key].judge = false; // 判断盒子打开关闭
            this.dataArray[key].fixTop = top; // 盒子定位高度
            this.dataArray[key].categoryAllData = categoryListData[key]; // 分组标签的信息
            this.dataArrayAddWFC(this.dataArray[key]);
          });
          this.category = categoryList;
          return Promise.resolve();
          break;
        case "template":
        case "sound":
          this.dataArray[this.boxName] = {}; // 分类数据总对象
          this.dataArray[this.boxName].data = []; // 保存数据
          this.dataArray[this.boxName].pIndex = 1; // 获取页码
          this.dataArray[this.boxName].judge = true; // 判断盒子打开关闭
          this.dataArray[this.boxName].fixTop = this.scollTop.default; // 盒子定位高度
          this.dataArray[this.boxName].categoryAllData = {
            id: this.boxName,
          };
          this.dataArrayAddWFC(this.dataArray[this.boxName]);
          this._getData(this.boxName);
          // return;
          break;
      }
      this.dataSet.style = this.StyleMsg;
      let categoryData = {};
      categoryData = { type: this.dataSet.type, style: this.StyleMsg };
      switch (this.boxName) {
        case "bg":
        case "scenes":
          categoryData.direction = this.optimized;
          break;
        case "props":
          categoryData.categoryType = 1;
      }

      return this.$http
        .get("/api/home/category", {
          // 获取分类标签
          params: categoryData,
        })
        .then((res) => {
          this.category = [];
          let dataCategory = res.data.data;
          if (this.boxName === "template") {
            let f = [];
            for (let k in dataCategory) {
              let firstCategory = dataCategory[k];
              for (let j in firstCategory.data) {
                let aa = firstCategory.data[j];
                f.push(aa);
              }
            }
            //console.log(JSON.stringify(f));
            dataCategory = f;
            // let keys = Object.keys(dataCategory);
            // dataCategory = dataCategory[keys[0]].data;
          }
          return Sequence(this.boxName, dataCategory).then((SequenceData) => {
            dataCategory = SequenceData.data;
            Object.keys(dataCategory).forEach((key) => {
              let index = this.category.length,
                top = 0;
              top = this.scollTop.default + index * this.scollTop.Incremental;
              this.category.push(dataCategory[key]);
              this.dataArray["_" + dataCategory[key].id] = {}; // 分类数据总对象
              this.dataArray["_" + dataCategory[key].id].data = []; // 保存数据
              this.dataArray["_" + dataCategory[key].id].pIndex = 1; // 获取页码
              this.dataArray["_" + dataCategory[key].id].judge = false; // 判断盒子打开关闭
              this.dataArray["_" + dataCategory[key].id].fixTop = top; // 盒子定位高度
              this.dataArray["_" + dataCategory[key].id].categoryAllData =
                dataCategory[key]; // 分组标签的信息
              this.dataArrayAddWFC(this.dataArray["_" + dataCategory[key].id]);
            });

            this.getOuterData && this.getOuterData();
          });
        })
        .catch((err) => console.warn(err));
    },
    dataArrayAddWFC(data, name) {
      // 添加元素的行列高度标记
      let rowNum = this.waterfallComputeData.listNum;
      switch (this.boxName) {
        case "bg":
        case "scenes":
          rowNum = name ? 2 : this.waterfallComputeData.listNum;
          break;
        case "shapes":
          rowNum = name ? 3 : this.waterfallComputeData.listNum;
          break;
      }

      for (let i = 0; i < rowNum; i++) {
        data.WFSheight = 0;
        data["WFSS" + i] = {};
        data["WFSS" + i].height = this.waterfallComputeData.default;
        data["WFSS" + i].index = i;
      }
      return data;
    },
    waterfallCompute(arrayData, data, name) {
      // 瀑布流计算
      let listKey = {},
        item = "";
      for (item in arrayData) {
        if (item.indexOf("WFSS") >= 0) {
          if (!arrayData.data.length) {
            arrayData[item].height = this.waterfallComputeData.default;
          }
        }
      }

      for (let i = 0; i < data.length; i++) {
        let itemList = [];
        for (item in arrayData) {
          if (item.indexOf("WFSS") >= 0) {
            itemList.push({
              key: item,
              data: arrayData[item],
            });
          }
        }
        listKey = false;
        if (itemList.length == 1) {
          listKey = itemList[0].key;
        } else {
          for (let v = 0; v < itemList.length; v++) {
            if (itemList[v + 1]) {
              let numdata =
                itemList[v].data.height - itemList[v + 1].data.height;

              if (numdata == 0 && !listKey) {
                listKey = itemList[v].key;
              } else if (numdata > 0) {
                listKey = itemList[v + 1].key;
              } else if (numdata < 0) {
                listKey = itemList[v].key;
              }
            }
          }
        }

        switch (this.boxName) {
          case "bg":
          case "scenes":
          case "template":
            switch (data[i].direction) {
              case 2:
                if (name && name == "search") {
                  data[i].leftWFC =
                    this.scollTop.materialW * arrayData[listKey].index;
                  data[i].topWFC =
                    arrayData[listKey].height >
                    this.waterfallComputeData.default
                      ? arrayData[listKey].height
                      : this.waterfallComputeData.default;
                  arrayData[listKey].height += 242;
                } else {
                  data[i].leftWFC =
                    this.scollTop.materialW2 * arrayData[listKey].index;
                  data[i].topWFC =
                    arrayData[listKey].height >
                    this.waterfallComputeData.default
                      ? arrayData[listKey].height
                      : this.waterfallComputeData.default;
                  arrayData[listKey].height += this.scollTop.materialH;
                }
                break;
              default:
                data[i].leftWFC =
                  this.scollTop.materialW * arrayData[listKey].index;
                data[i].topWFC =
                  arrayData[listKey].height > this.waterfallComputeData.default
                    ? arrayData[listKey].height
                    : this.waterfallComputeData.default;
                arrayData[listKey].height += this.scollTop.material;
                break;
            }

            if (!this.S_GlobalSearch && offsetsOfNoCover[this.boxName]) {
              data[i].topWFC -= offsetsOfNoCover[this.boxName];
            }

            break;
          case "shapes":
            if (name && name == "search") {
              data[i].leftWFC = 94 * arrayData[listKey].index;
            } else {
              data[i].leftWFC =
                this.scollTop.materialW * arrayData[listKey].index;
            }

            data[i].topWFC =
              arrayData[listKey].height > this.waterfallComputeData.default
                ? arrayData[listKey].height
                : this.waterfallComputeData.default;
            arrayData[listKey].height += this.scollTop.material;
            break;
          default:
            data[i].leftWFC =
              this.scollTop.materialW * arrayData[listKey].index;
            data[i].topWFC =
              arrayData[listKey].height > this.waterfallComputeData.default
                ? arrayData[listKey].height
                : this.waterfallComputeData.default;
            arrayData[listKey].height += this.scollTop.material;
            break;
        }

        arrayData.WFSheight = arrayData[listKey].height;
      }
      return arrayData.data.concat(data);
    },
    collectionSpriteIconFS(data, e, type, del) {
      // 收藏/取消收藏
      let fileTypes = {
        // 30 素材组合
        shapes: [6, 7, 8, 9, 28, 29, 30, 33],
        gif: [32],
      };

      let isCollection = e.target.className,
        msgData = {
          id: data.id,
          type: 3,
        };
      let judgeHttp = true;
      let dataURL = "user/favorites";
      switch (this.boxName) {
        case "bg":
          msgData.type = 3;
          break;
        case "characters":
          msgData.type = 14;
          break;
        case "gif":
          msgData.type = 37;
          break;
        case "props":
          msgData.type = 17;
          if (fileTypes.shapes.indexOf(data.fileType) > -1) {
            msgData.type = 15;
          } else if (fileTypes.gif.indexOf(data.fileType) > -1) {
            msgData.type = 37;
          }
          break;
        case "shapes":
          msgData.type = 15;
          break;
        case "scenes":
          msgData.type = 12;
          break;
        case "template":
          dataURL = del
            ? "user/template/cancelFavorites"
            : "user/template/favorites";
          delete msgData.type;
          break;
        case "sound":
          msgData.type = 5;
          break;
        case "text":
          msgData.type = 16;
          break;
        case "personal":
          judgeHttp = false;

          if (type == "template") {
            judgeHttp = true;
            dataURL = del
              ? "user/template/cancelFavorites"
              : "user/template/favorites";
          } else {
            if (data.favorites) {
              judgeHttp = true;
            }
            msgData.type = type;
          }
          break;
      }
      isCollection = isCollection.indexOf("collection_sprite_icon_active") >= 0;

      if (isCollection && !del) {
        // 已收藏
        this.$bus.emit("FeaturesPop_vue", {
          name: "settingMessage",
          typeName: "bg",
          posx: this.MaterialPane_Size.width + 10,
          posy: e.clientY,
          type: 2,
          data: {
            data,
            e: e,
            type,
          },
          msg: {
            title: "请确认是否取消收藏您所选择的素材？",
            leftTit: "取消",
            rightTit: " 确认",
          },
          boxName: this.boxName,
        });
        this.$bus.emit("settingMessage_vue", {
          posx: this.MaterialPane_Size.width + 10,
          posy: e.clientY,
          data: {
            data,
            e: e,
            type,
          },
          msg: {
            title: "请确认是否取消收藏您所选择的素材？",
            leftTit: "取消",
            rightTit: " 确认",
          },
          boxName: this.boxName,
        });
        return;
      }
      if (del) {
        if (this.boxName != "template") {
          msgData.isCancel = 1;
        }
        if (!judgeHttp) {
          this.$http
            .delete("/api/user/scene/" + data.id, { id: data.id }) // 取消我的场景页
            .then((resScenes) => {
              if (del && this.boxName == "personal") {
                for (let j in this.dataArray) {
                  if (this.dataArray[j].judge) {
                    this.dataArray[j].data = [];
                    this.dataArray[j].pIndex = 1;
                    this.getUserData(j);
                    break;
                  }
                }
              }
            })
            .catch((Serror) => {
              console.log(Serror, "失败");
            });
        }
      }

      let item = data;
      let collect_contents = {
        template: "模板",
        scenes: "场景",
        bg: "背景",
        text: "文字",
        characters: "人物",
        props: "道具",
        sound: "声音",
      };
      let _key = this.boxName;
      if (this.boxName === "personal") {
        _key =
          $(this.$el).find(".data-body .operation").eq(0).data("cate-name") ||
          "";
      }
      sensors.track("collectContent", {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: "",
        collect_content: collect_contents[_key] || "",
        content_duration: this.TOOL.getDuration() / 1000,
        content_id: this.WorksId,
        content_name: this.WorksName,
        material_id: item.id,
        // material_name: item.title,
        module: "编辑器素材栏",
        operation_type: msgData.isCancel == 1 ? "取消收藏" : "收藏",
        price_type: ((payType) => {
          if (payType == 0) {
            return "免费";
          }
          if (payType == 1) {
            return "付费";
          }
          if (payType == 4) {
            return "会员免费";
          }
          return "全部价格";
        })(item.payType),
        price: item.price - 0,
        purpose: "",
        template_id: this.$route.template || "",
        template_name: "",
        template_style: "",
        template_type: "",
      });
      if (judgeHttp) {
        this.$http({
          url: "/api/" + dataURL,
          method: "post",
          data: msgData,
        }).then((res) => {
          let resData = res.data;

          if (resData.code == 200) {
            if (isCollection) {
              // 已收藏
              // e.target.classList.remove('collection_sprite_icon_active')
              if (del && this.boxName == "personal") {
                for (let j in this.dataArray) {
                  if (this.dataArray[j].judge) {
                    this.dataArray[j].data = [];
                    this.dataArray[j].pIndex = 1;
                    this.getUserData(j);
                    break;
                  }
                }
              }
            }
            this.collectionSpriteIconTit(e, "vipResource_" + data.id);
          }
        });
      }
    },
    collectionSpriteIconTit(e, className) {
      // 收藏取消收藏方法
      let titDom = e.target.attributes["aria-describedby"].value,
        num = 0,
        titDomTXT;
      let isCollection = e.target.className;
      isCollection = isCollection.indexOf("collection_sprite_icon_active") >= 0;

      let timeoutid = setInterval(() => {
        num++;
        titDomTXT = document.getElementById(titDom);
        if (titDomTXT) {
          titDomTXT.style.opacity = "0";
          let name = titDomTXT.innerHTML.indexOf("<");
          name = titDomTXT.innerHTML.substring(name);

          if (isCollection) {
            // 已收藏
            name = "取消收藏" + name;
            if (this.boxName == "personal") {
              this.materialPushAnalysisTwo("collectionSpritePersonalDel");
            } else {
              this.materialPushAnalysisTwo("collectionSpriteDel");
            }
          } else {
            // 未收藏
            name = "收藏" + name;
            if (this.boxName == "personal") {
              this.materialPushAnalysisTwo("collectionSpritePersonalAdd");
            } else {
              this.materialPushAnalysisTwo("collectionSpriteAdd");
            }
          }
          titDomTXT.innerHTML = name;
          titDomTXT.style.opacity = "1";
        }
        let delDom = document.getElementsByClassName(className);
        if (delDom.length) {
          for (let i = 0; i < delDom.length; i++) {
            // 循环添加删除显示收藏的元素的class
            if (isCollection) {
              // 已收藏
              delDom[i].classList.remove("collection_sprite_icon_active");
            } else {
              // 未收藏
              delDom[i].classList.add("collection_sprite_icon_active");
            }
          }
        }
        if (num > 30 || titDomTXT) {
          clearInterval(timeoutid);
        }
      }, 50);
    },
    loadLottie(data, dom, judge) {
      // 加载lottie
      if (this.loadLottieSetTime) {
        clearTimeout(this.loadLottieSetTime);
      }
      let fileName = data.url.split(".")[1];
      if (fileName === "json" || fileName === "gif") {
        const vm = this;
        if (judge) {
          this.loadLottieSetTime = setTimeout(() => {
            switch (data.fileType) {
              case 32:
                let imgDom = vm.$refs[dom.id][dom.index].previousElementSibling;
                imgDom.src = this.$handleAssetsUrl(data.url);
                break;
              case 42:
                let videoDom =
                  vm.$refs[dom.id][dom.index].previousElementSibling;
                videoDom.currentTime = 0;
                videoDom.play();
                this.materialPushAnalysis({ type: "propsSoundSprite" });
                break;
              default:
                const lContainer = vm.$refs[dom.id][dom.index];
                let option = {
                  container: lContainer,
                  renderer: "svg",
                  loop: true,
                  autoplay: false,
                  path: this.$handleAssetsUrl(data.url),
                };
                this.lottiedata = lottie.loadAnimation(option);
                this.lottiedata.play();
            }
            clearTimeout(this.loadLottieSetTime);
          }, 100);
        } else {
          switch (data.fileType) {
            case 32:
              let imgDom = vm.$refs[dom.id][dom.index].previousElementSibling;
              imgDom.src = this.$handleAssetsUrl(data.thumbnailUrl);
              break;
            case 42:
              let videoDom =
                this.$refs[dom.id][dom.index].previousElementSibling;
              videoDom.pause();
              break;
            default:
              if (this.lottiedata) {
                this.lottiedata.stop();
                this.lottiedata.destroy();
                this.lottiedata = null;
              }
          }
        }
      }
    },
    loadLottieShapes(data, dom, judge) {
      // 加载lottie
      if (this.loadLottieSetTime) {
        clearTimeout(this.loadLottieSetTime);
      }
      let fileName = data.url.split(".")[1];
      if (
        fileName !== "json" ||
        data.fileType === 9 ||
        data.fileType === 30 /* 素材组合 */
      ) {
        return;
      }
      if (judge) {
        this.loadLottieSetTime = setTimeout(() => {
          let option = {
            container: this.$refs[dom.id][dom.index],
            renderer: "svg",
            loop: true,
            autoplay: false,
            path: this.$handleAssetsUrl(data.url),
          };
          this.lottiedata = lottie.loadAnimation(option);
          this.lottiedata.play();
          clearTimeout(this.loadLottieSetTime);
        }, 100);
      } else {
        if (this.lottiedata) {
          this.lottiedata.stop();
          this.lottiedata.destroy();
          this.lottiedata = null;
        }
      }
    },
    loadLottieCharacters(data, dom, judge) {
      // 加载lottie
      this.loadLottieShapes(data, dom, judge);
    },
    addTemplate(data) {
      console.log(JSON.stringify(data));
      this.$bus.emit("addTemplate", data);
      this.$analysis(
        "resource_area,click_sin_template,素材资源区_点击_单个模板"
      );
    },
    callSpriteLib(opt) {
      this.materialLib_Nav_Param.optimized = this.TOOL.optimized;
      if (opt) {
        this.materialLib_Nav_Param.category = opt.category;
      }
      this.$store.commit("open_TemplateMaterialLibDialogMsg", {
        materialType: namesDict[this.dataMsg],
        navParam: Object.assign({}, this.materialLib_Nav_Param),
      });
    },
  },
  components: {
    SwitchStyle,
    CategoryPrompt,
    FilterSprites,
    vipLabel,
    sectionCategory,
    company,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mixins/rightnavSlide.vue